/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const permissionSchema = z.object({
      "id": z.string().describe("Id du groupe sur Keycloak"),
  "url": z.string().url().describe("URL de l'icône représentant le logiciel"),
  "softwareName": z.string().describe("Nom du logiciel"),
  "hasAccess": z.boolean().describe("Indique si l'utilisateur a accès à ce logiciel").optional()
      })